module.exports = "<app-private-message [message]=\"data.message\"></app-private-message>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/user-pm/message-dialog/message-dialog.component.html
// module id = ../../../../../src/app/users/user-pm/message-dialog/message-dialog.component.html
// module chunks = 1